<template>
  <div id="createFolder">
    <div
      class="confirm"
    >
      <form @submit.prevent>
        <!-- NAME -->
        <div class="form-group">
          <label for="folderName">Folder Name</label>
          <input
            v-model="tempFolder.name"
            id="folderName"
            class="form-control"
          />
        </div><!-- /.form-group -->

        <!-- DESCRIPTION -->
        <div class="form-group">
          <label for="folderDescription">Folder Description</label>
          <textarea
            v-model="tempFolder.description"
            id="folderDescription"
            class="form-control"
          />
          <!-- Editors -->
          <div id="folderEditors" class="mt-3">
            <p class="mb-1"><strong>Folder Permissions</strong><br><small>Grant access to view and edit all datasets within this folder.</small></p>
            <b-form-checkbox-group
              v-model="folderEditors"
              :options="editorOptions"
              class="mb-3"
              value-field="id"
              text-field="email"
              @change="updateEditors"
            ></b-form-checkbox-group>
          </div><!-- /#folderEditors -->
        </div><!-- /.form-group -->
        <button
          v-if="$store.state.editMode"
          class="btn btn-success mr-1"
          @click="saveFolder()"
        >
          Save
        </button>
        <button
          v-if="!$store.state.editMode"
          class="btn btn-success mr-1"
          @click="saveFolder()"
        >
          Create Folder
        </button>
        <button
          class="btn btn-secondary mr-1"
          @click="closeCreateFolder()"
        >
          Cancel
        </button>
        <button
          v-if="$store.state.editMode"
          class="btn btn-danger"
          @click="trashFolder()"
        >
          Trash
        </button>
      </form>
    </div><!-- /.confirm -->
  </div><!-- /#confirm -->
</template>

<script>
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      tempFolder: {
        name: '',
        description: ''
      },
      editorOptions: [],
      folderEditors: []
    }
  },
  props: ['selectedFolder'],
  created () {
    this.gatherEditorOptions()
    if (!this.$store.state.editMode) {
      this.tempFolder.name = ''
      this.tempFolder.description = ''
    } else {
      this.tempFolder = this.selectedFolder
      this.folderEditors = this.selectedFolder.editors
    }
  },
  computed: {
    folder: {
      get () {
        return this.$store.state.folder
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'folder', value: value })
      }
    }
  },
  methods: {
    updateEditors (e) {
      this.folderEditors = e
      console.log(this.folderEditors)
    },
    gatherEditorOptions () {
      this.folderEditors = this.folder.editors || []
      this.$store.state.farm.collaboratorData.forEach(collaborator => {
        const collaboratorId = collaborator.id
        const permissionLevel = this.$store.state.farm.permissions[collaboratorId]
        if (permissionLevel === 'Permission-only' || permissionLevel === 'Read-only') {
          this.editorOptions.push(collaborator)
        }
      })
    },
    closeCreateFolder () {
      this.$store.commit('setStateProperty', { property: 'editMode', value: false })
      this.$store.commit('setStateProperty', { property: 'createFolderPrompt', value: false })
    },
    saveFolder () {
      if (this.$store.state.editMode) {
        fb.foldersCollection.doc(this.tempFolder.id).update({
          updatedOn: new Date(),
          updatedBy: this.$store.state.currentUser.uid,
          name: this.tempFolder.name,
          description: this.tempFolder.description,
          editors: this.folderEditors
        }).then(() => {
          this.closeCreateFolder()
        })
      } else {
        fb.foldersCollection.add({
          createdOn: new Date(),
          updatedOn: new Date(),
          createdBy: this.$store.state.currentUser.uid,
          updatedBy: this.$store.state.currentUser.uid,
          farmId: this.$store.state.farm.id,
          name: this.tempFolder.name,
          description: this.tempFolder.description,
          editors: this.folderEditors,
          folderId: this.$store.state.folder.id
        }).then(() => {
          this.$store.commit('setStateProperty', { property: 'createFolderPrompt', value: false })
        })
      }
    }
  }
}
</script>

<style scoped>
#createFolder {
  position: absolute;
  padding: 20px;
  border-radius: 4px;
  z-index: 999;
  top: 120px;
  left: 80px;
  width: 300px;
  background-color: #eee;
  box-shadow: 1px 2px 3px rgba(0,0,0,0.4);
}
</style>
